import $ from 'jquery';

export const init = () => {

	calcViewPort();

	function calcViewPort() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	$(window)
		.on('resize orientationchange', function() { calcViewPort(); });
};
